import { module as modujs } from "modujs";
import Swiper from "swiper";
import { Navigation, EffectFade, Pagination, Autoplay, Scrollbar, Thumbs, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/thumbs";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

export default class extends modujs {
	constructor(m) {
		super(m);
	}

	init() {
		const config = JSON.parse(this.el.getAttribute("data-config"));
		this.id = this.el.getAttribute("data-module-swiper");
		const isThumb = this.el.hasAttribute("thumbsSlider");
		const mainId = this.el.getAttribute("data-thumbs-for");

		this.swiper = new Swiper(this.el, {
			...config,
			modules: [Navigation, EffectFade, Pagination, Autoplay, Scrollbar, Thumbs, FreeMode],
			...(isThumb && mainId
				? {}
				: {
						navigation: {
							prevEl: `.o-swiper_actions[data-swiper-for="${this.id}"] .o-swiper_btn.-prev`,
							nextEl: `.o-swiper_actions[data-swiper-for="${this.id}"] .o-swiper_btn.-next`,
						},
					}),
			pagination: {
				el: `.o-swiper_actions[data-swiper-for="${this.id}"] .o-swiper_pagination`,
				clickable: true,
				type: config.pagination?.type || "bullets",
			},
			wrapperClass: "o-swiper_wrapper",
			slideClass: "o-swiper_slide",
		});

		if (isThumb) {
			window.__swiperThumbs = window.__swiperThumbs || {};
			window.__swiperThumbs[this.id] = this.swiper;

			if (mainId) {
				const prevBtn = this.el.querySelector(".o-swiper_btn.-prev");
				const nextBtn = this.el.querySelector(".o-swiper_btn.-next");

				if (prevBtn) {
					prevBtn.addEventListener("click", () => {
						window.__swiperInstances?.[mainId]?.slidePrev();
					});
				}

				if (nextBtn) {
					nextBtn.addEventListener("click", () => {
						window.__swiperInstances?.[mainId]?.slideNext();
					});
				}
			}
		}

		window.__swiperInstances = window.__swiperInstances || {};
		window.__swiperInstances[this.id] = this.swiper;

		if (config.thumbs?.swiperId) {
			const thumbId = config.thumbs.swiperId;
			const thumbInstance = window.__swiperThumbs?.[thumbId];

			if (thumbInstance) {
				this.swiper.thumbs.swiper = thumbInstance;
				this.swiper.thumbs.init();
				this.swiper.thumbs.update(true);
			}
		}
	}

	destroy() {
		if (this.swiper) {
			this.swiper.destroy(true, true);
		}
	}
}
